import { call, put, takeLatest } from 'redux-saga/effects';
import moment from 'moment';
import { YieldOf } from 'types/utils';
import { fetch as fetchAction, success, error } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchStationsServedActionPayload = ReturnType<typeof fetchAction>;

export function* fetchStationsServedSaga({ meta }: FetchStationsServedActionPayload) {
  const { getStationsServed } = getAPI();
  const response: YieldOf<typeof getStationsServed> = yield call(
    getStationsServed,
    meta.name,
    moment(meta.date).format('YYYY-MM-DD')
  );
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(success(data));
  } else {
    const requestError = problem || 'unknown';
    yield put(error(requestError));
  }
}

export default function* stationsServedSaga() {
  yield takeLatest(fetchAction.type, fetchStationsServedSaga);
}
